import { useState, useEffect } from 'react'
import { supabase } from './supabase'
import LandingPage from './LandingPage'
import Login from './Login'
import Dashboard from './Dashboard'

function App() {
  const [page, setPage] = useState('landing')
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser(session.user)
        setPage('dashboard')
      }
      setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUser(session.user)
        setPage('dashboard')
      } else {
        setUser(null)
        setPage('landing')
      }
    })

    return () => subscription.unsubscribe()
  }, [])

  const handleLogout = async () => {
    await supabase.auth.signOut()
    setUser(null)
    setPage('landing')
  }

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#080c18', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <svg viewBox="0 0 36 36" width="36" height="36">
            <defs><linearGradient id="load" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#1e3a5f"/><stop offset="100%" stopColor="#0f2440"/></linearGradient></defs>
            <rect x="0" y="0" width="36" height="36" rx="7" fill="url(#load)"/>
            <polygon points="9,27 9,9 12.5,9 18,17 23.5,9 27,9 27,27 23.5,27 23.5,15 18,23 12.5,15 12.5,27" fill="white"/>
          </svg>
          <p style={{ color: '#64748b', marginTop: '1rem', fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif', fontSize: '0.9rem' }}>Loading...</p>
        </div>
      </div>
    )
  }

  switch (page) {
    case 'login':
      return <Login onLogin={(u) => { setUser(u); setPage('dashboard') }} />
    case 'dashboard':
      return <Dashboard user={user} onLogout={handleLogout} />
    default:
      return <LandingPage onGetStarted={() => setPage('login')} onLogin={() => setPage('login')} />
  }
}

export default App
